export default {
  'title': 'Modify email address',
  'submit': 'Confirm',
  'cencel': 'Cancel',
  'success': 'Email modified successfully, you will be redirected to the login page.',
  'sendSuccess': 'Email sent successfully',
  'error': {
    '0': 'Verification code has expired',
    '1': 'Verification code is incorrect',
    '2': 'The new email address cannot be the same as the old email address.',
    '3': 'Email address format is incorrect'
  },
  'getCode': 'Get a verification code',
  'newTip': 'Please enter the email address you’d like to link up, and after changing the email address, you can log in or retrieve the password via email.',
  'oldTip': 'Click to get the verification code, and we will send an email to the email address specified in {0}.',
  'code': 'Please fill in the verification code.',
  'reset': 'Get code again',
  'showTip1': 'Your verification code has been sent to the email address specified in {0}. Please check your mailbox.',
  'showTip2': 'Your verification code has been sent to the email address specified in {0} <a target="_blank" href="{1}">Click here to enter</a>'
}
